import { useQuery, useLazyQuery } from '@apollo/client';
import { Stack } from '@mui/material';
import { isEmpty } from 'lodash';
import React, { useEffect, useState, useCallback, useContext } from 'react';
import clientGraphql from '../../../common/apollo-graphql';
import { REFERRAL_PATIENT_DETAIL, REFERRAL_PATIENT_MINI_DETAIL } from '../gql/Referral/Query';
import AuthContext from '../../auth/context/AuthContext';
import PatientInfoContainer from './patientInfo/PatientInfoContainer';
import ReferralInfoContainer from './referralInfo/ReferralInfoContainer';

export function useGetPatientPhoneNumber() {
  const [getData] = useLazyQuery(REFERRAL_PATIENT_MINI_DETAIL, {
    client: clientGraphql,
    fetchPolicy: 'network-only'
  });

  const getPatientPhoneNumber = useCallback(async (referralUuid) => {
    const data = await getData({
      variables: {
        uuid: referralUuid,
      }
    });

    const patientPhoneNumber = data?.data?.patient?.phone ?? null;

    return {
      patientPhoneNumber,
    };
  }, [getData]);

  return {
    getPatientPhoneNumber
  };
}

function PatientDetails({ referralId, isDraft, parsedData = {}, referralRefetch }) {
  const currentUser = useContext(AuthContext);
  const [details, setDetails] = useState({});

  const gqlParams = {
    client: clientGraphql,
    variables: {
      uuid: referralId
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    refetchOnWindowFocus: false,
  };
  const { data: patientFullDetail, refetch } = useQuery(REFERRAL_PATIENT_DETAIL, {
    ...gqlParams,
  });

  const refetchAll = async () => {
    await Promise.all([refetch(), referralRefetch()]);
  };
  
  useEffect(() => {
    if (!isEmpty(patientFullDetail?.patient)) {
      setDetails({ ...patientFullDetail.patient });
    } 
  }, [patientFullDetail]);

  return (
    <Stack spacing={3} direction="row" sx={{ width: '100%' }}>
      <PatientInfoContainer
        details={details}
        isDraft={isDraft}
        referralUuid={referralId}
        refetch={refetch}
      />

      <ReferralInfoContainer
        details={{
          ...details,
          ...parsedData,
          parsedData: parsedData,
          currentUser,
          diagnosis: parsedData?.diagnosis?.description,
          referralExtraInfo: parsedData?.referral?.getExtraInfo(),
        }}
        isDraft={isDraft}
        referralUuid={referralId}
        refetch={refetchAll}
      />
    </Stack>

  );
}

export default React.memo(PatientDetails);
